// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelLogoSelector_Wvaq0 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #717171;
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #717171;
  gap: 5px;
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 10px;
  margin-bottom: 0.5rem;
}

.radioInputLogoSelector_rAYKD {
  height: 20px !important;
  min-width: 20px;
  max-width: 20px;
  border-radius: 999px !important;
}

.row_Fggnt {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p,
  span {
    margin: 5px 0;
    color: #000 !important;
    margin: 0;
    font-weight: 500;
    font-size: 15px;
  }
}

.button_O3z13,
.facturacionButtonEdit_EMv0i {
  text-decoration: underline;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  font-size: 14px;
  font-weight: 600;
  color: var(--_2-color);
  opacity: 0;
}

label:hover,
.label_F11ye:hover {

  .button_O3z13,
  .editButton_SVHKD {
    opacity: 1;
  }
}

.editButton_SVHKD {
  text-decoration: underline;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
  font-weight: 600;
  color: var(--_2-color);
  opacity: 0;
}

.logoCorporativo_IAdwS {
  display: flex;
  align-items: center;
  margin-top: 15px;
  flex-wrap: wrap;
  gap: 10px;

  .container_BK2xO {
    display: flex;
    align-items: center;
    position: relative;

    img {
      width: 80px;
      height: 80px;
    }

    .delete_dCTHa {
      position: absolute;
      height: 20px;
      width: 20px;
      top: -7px;
      right: -7px;
      background-color: #dc3545;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      -ms-border-radius: 50%;
      -o-border-radius: 50%;
      font-size: 20px;
      color: var(--white-color);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}

@media (width <=658px) {
  .form_GNdPB {

    .button_O3z13,
    .facturacionButtonEdit_EMv0i,
    .editButton_SVHKD {
      opacity: 1;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/LogoSelector/LogoSelector.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,QAAQ;EACR,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB;;IAEE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;;EAEE,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;;EAGE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,SAAS;;EAET;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;;IAElB;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,SAAS;MACT,WAAW;MACX,yBAAyB;MACzB,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,eAAe;MACf,yBAAyB;MACzB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;IACjB;EACF;AACF;;AAEA;EACE;;IAEE;;;MAGE,UAAU;IACZ;EACF;AACF","sourcesContent":[".labelLogoSelector {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #717171;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  color: #717171;\n  gap: 5px;\n  border-bottom: 1px solid #ebebeb;\n  padding-bottom: 10px;\n  margin-bottom: 0.5rem;\n}\n\n.radioInputLogoSelector {\n  height: 20px !important;\n  min-width: 20px;\n  max-width: 20px;\n  border-radius: 999px !important;\n}\n\n.row {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  p,\n  span {\n    margin: 5px 0;\n    color: #000 !important;\n    margin: 0;\n    font-weight: 500;\n    font-size: 15px;\n  }\n}\n\n.button,\n.facturacionButtonEdit {\n  text-decoration: underline;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--_2-color);\n  opacity: 0;\n}\n\nlabel:hover,\n.label:hover {\n\n  .button,\n  .editButton {\n    opacity: 1;\n  }\n}\n\n.editButton {\n  text-decoration: underline;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--_2-color);\n  opacity: 0;\n}\n\n.logoCorporativo {\n  display: flex;\n  align-items: center;\n  margin-top: 15px;\n  flex-wrap: wrap;\n  gap: 10px;\n\n  .container {\n    display: flex;\n    align-items: center;\n    position: relative;\n\n    img {\n      width: 80px;\n      height: 80px;\n    }\n\n    .delete {\n      position: absolute;\n      height: 20px;\n      width: 20px;\n      top: -7px;\n      right: -7px;\n      background-color: #dc3545;\n      border-radius: 50%;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      -o-border-radius: 50%;\n      font-size: 20px;\n      color: var(--white-color);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n    }\n  }\n}\n\n@media (width <=658px) {\n  .form {\n\n    .button,\n    .facturacionButtonEdit,\n    .editButton {\n      opacity: 1;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelLogoSelector": `labelLogoSelector_Wvaq0`,
	"radioInputLogoSelector": `radioInputLogoSelector_rAYKD`,
	"row": `row_Fggnt`,
	"button": `button_O3z13`,
	"facturacionButtonEdit": `facturacionButtonEdit_EMv0i`,
	"label": `label_F11ye`,
	"editButton": `editButton_SVHKD`,
	"logoCorporativo": `logoCorporativo_IAdwS`,
	"container": `container_BK2xO`,
	"delete": `delete_dCTHa`,
	"form": `form_GNdPB`
};
export default ___CSS_LOADER_EXPORT___;
